"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = groupStatsByCompDay;
function groupStatsByCompDay(entriesByDivisions) {
  const statsByCompDayID = {};
  const statsByCompDays = [];
  const divsInUseByID = {};
  const divsInUse = [];
  const entriesByCoreDivisions = entriesByDivisions.filter(e => e.isCoreTier);
  for (const div of entriesByCoreDivisions) {
    const compDayID = div.competitionDayID;
    if (!statsByCompDayID[compDayID]) {
      statsByCompDayID[compDayID] = {
        ...div,
        competitionDayID: compDayID,
        entriesByDivisionID: {}
      };
      statsByCompDays.push(statsByCompDayID[compDayID]);
    }
    statsByCompDayID[compDayID].entriesByDivisionID[div.tierRef] = div.entries;
    const divID = div.tierRef;
    if (!divsInUseByID[divID]) {
      divsInUseByID[divID] = div;
      divsInUse.push(div);
    }
  }
  divsInUse.sort((a, b) => a.divLevel - b.divLevel);
  return [statsByCompDays, divsInUse];
}